<template>
  <div class="layout-template-cascade"
       @click="toggleVisible">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridCascade :content="content"
                     :visible.sync="visible"
                     v-bind="$attrs"
                     v-on="$listeners">
      <slot name="content"
            :visible="visible"
            :hide-popover="hidePopover"></slot>
    </DataGridCascade>
  </div>
</template>

<script>
import DataGridCascade from './grid/DataGridCascade'
export default {
  name: 'TemplateCascade',
  components: {
    DataGridCascade
  },
  props: {
    content: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    hidePopover () {
      this.visible = false
    }
  }
}
</script>

<style lang="scss">
  .layout-template-cascade {
    display: inline-block;
  }
</style>
